import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import oldP from "../assets/engegment/old-p.png";
import newP from "../assets/engegment/new-p.png";

const NewPatientBookings = ({ newBookings, oldBookings }) => {
  const options = {
    chart: {
      type: "pie",
      height: "135px",

      backgroundColor: "transparent",
    },
    title: {
      text: "",
    },
    plotOptions: {
      pie: {
        innerSize: "70%",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    series: [
      {
        name: "Bookings",
        data: [
          { name: "new bookings", y: oldBookings, color: "#D9D9D9" },
          { name: "old bookings", y: newBookings, color: "#936EE2" },
        ],
      },
    ],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <div className="w-[30%] bg-white shadow-lg rounded-2xl ml-2 ">
      <h2 className="text-[14px] ml-3 mb-1 mt-2 font-semibold p-2">
        New Patient Bookings
      </h2>
      <div className="border-b border-[#D7E4EB]"></div>
      <div>
        <div className="flex justify-between items-center pt-4 ml-3">
          <div className="flex items-center ml-2">
            <img src={oldP} className="h-2 w-2" />
            <p className="text-[10px] ml-2">Old Patients Booking</p>
          </div>
          <div className="flex">
            <p className="text-[12px] mr-4">{oldBookings}</p>
          </div>
        </div>
        <div className="flex justify-between items-center mt-2 ml-3">
          <div className="flex items-center ml-2">
            <img src={newP} className="h-2 w-2" />
            <p className="text-[10px] ml-2">New Patients Booking</p>
          </div>
          <div className="flex">
            <p className="text-[blue] text-[12px] mr-4">{newBookings}</p>
          </div>
        </div>
      </div>
      <div className="relative mt-[5px]">
        <HighchartsReact highcharts={Highcharts} options={options} />
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-[16px] font-semibold">
            {newBookings + oldBookings}
          </span>
          <div className="text-[12px] text-gray-400 w-[10vh] text-center">
            Total
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewPatientBookings;
